import { createSelector } from 'reselect';
import getModuleState from './moduleStateSelector';

const getIsXsTabOpen = createSelector(
  getModuleState,
  (state) => state.get('isXsTabOpen')
);

export default getIsXsTabOpen;
